import React from 'react';
interface ContentLayoutProps {
  children: React.ReactNode;
}
export function ContentLayout({
  children
}: ContentLayoutProps) {
  return <div className="px-8 md:px-16 py-12 md:py-16" data-id="element-219">
      <div className="max-w-[65ch]" data-id="element-220">
        {children}

        {/* Copyright & LinkedIn for mobile view */}
        <div className="mt-12 md:hidden flex justify-between items-center" data-id="element-221">
          <p className="text-fluid-sm text-[#7A8290]" data-id="element-222">© All rights reserved</p>
          <a href="https://www.linkedin.com/in/mintextract/" target="_blank" rel="noopener noreferrer" className="text-fluid-sm text-[#7A8290] hover:text-[#111111] transition-colors duration-300" data-id="element-223">
            LinkedIn
          </a>
        </div>
      </div>
    </div>;
}